<script>
	import { browser } from '$app/environment';
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	import { Scrollactive } from 'svelte-scrollactive';

	let { children } = $props();

	let scrollContainer = $state();
	async function onItemChanged({ detail }) {
		scrollContainer.scrollTo({
			left: detail?.currentItem?.offsetLeft - 50,
			behavior: 'smooth',
		});
	}
</script>

<!-- eslint-disable better-tailwindcss/no-unknown-classes -->

<Section
	class="sticky! top-0 z-20 py-0!"
	innerClass="!py-0 !max-w-full"
	backgroundColor="grey-light"
>
	<div
		class="
    full-width sticky w-full overflow-x-auto border-b-2 border-indow-blue
    shadow-md
    [&_nav]:grid [&_nav]:justify-items-center
  "
		bind:this={scrollContainer}
	>
		{#if browser}
			<Scrollactive
				activeClass="active"
				highlightFirstItem
				scrollOnStart={false}
				on:itemchanged={onItemChanged}
				offset={50}
				modifyUrl={false}
			>
				<!-- eslint-disable-next-line better-tailwindcss/no-unknown-classes -->
				<ol
					class="
       nav-center flex w-fit list-none flex-row justify-center gap-[3px]
       text-center
       [&_a]:w-40 [&_a]:bg-indow-blue [&_a]:p-4 [&_a]:font-bold
       [&_a]:hyphens-none [&_a]:text-indow-white [&_a]:no-underline
       [&_a]:transition-colors
       [&_li]:contents
     "
				>
					{@render children?.()}
				</ol>
			</Scrollactive>
		{:else}
			<nav>
				<!-- eslint-disable better-tailwindcss/no-unknown-classes -->
				<ol
					class="
       nav-center flex w-fit list-none flex-row justify-center gap-[3px]
       text-center
       [&_a]:w-40 [&_a]:bg-indow-blue [&_a]:p-4 [&_a]:font-bold
       [&_a]:hyphens-none [&_a]:text-indow-white [&_a]:no-underline
       [&_a]:transition-colors
       [&_li]:contents
     "
				>
					<!-- eslint-enable better-tailwindcss/no-unknown-classes -->
					{@render children?.()}
				</ol>
			</nav>
		{/if}
	</div>
</Section>

<style>
	.nav-center :global(.active) {
		background: var(--color-indow-white);
		color: var(--color-indow-blue);
	}
</style>
